<div>
  <div class="prose">
    <h1>Users</h1>
  </div>

  <div class="pt-8">
    <div class="mb-4 flex justify-between">
      <div class="prose">
        <h2 class="ml-6">Active Users</h2>
      </div>
      @if (!errorFetchingUsers && users) {
        <button
          class="btn btn-primary btn-sm"
          onclick="inviteUserModal.showModal()"
        >
          Invite a User
        </button>
      }
    </div>

    @if (errorFetchingUsers) {
      <div class="text-center">
        <p class="text-error">Error fetching users</p>
      </div>
    } @else if (loadingUsers) {
      <div class="flex justify-center">
        <div class="loading loading-spinner loading-lg"></div>
      </div>
    } @else if (users) {
      <dialog
        #inviteUserModal
        id="inviteUserModal"
        class="modal modal-top sm:modal-middle"
      >
        <div class="modal-box overflow-visible">
          <h3 class="text-lg font-bold">Invite a User</h3>
          @if (errorFetchingRoles) {
            <div>
              <p class="py-4 text-error">Error fetching roles</p>
              <div class="modal-action">
                <form method="dialog">
                  <button class="btn btn-neutral">Cancel</button>
                </form>
              </div>
            </div>
          } @else if (loadingRoles) {
            <div class="flex justify-center py-4">
              <div class="loading loading-spinner loading-lg"></div>
            </div>
          } @else if (roles) {
            <div>
              <div class="py-4">
                @if (!sending) {
                  <div>
                    <label class="form-control w-full">
                      <div class="label">
                        <span class="label-text">Email</span>
                      </div>
                      <input
                        type="text"
                        class="input input-bordered w-full"
                        [(ngModel)]="inviteEmail"
                        placeholder="Email"
                      />
                    </label>
                    <div class="mt-4">
                      <p class="px-1 py-2 text-sm">Role</p>
                      <div class="dropdown w-full">
                        <div
                          tabindex="0"
                          role="button"
                          class="btn w-full justify-between border-base-content/20 bg-base-100"
                        >
                          <span>{{ selectedRoleDisplayName }}</span>
                          <app-chevron-down-icon
                            class="h-5 w-5"
                          ></app-chevron-down-icon>
                        </div>
                        <ul
                          tabindex="0"
                          class="menu dropdown-content z-[1] w-80 rounded-box bg-base-100 p-2 shadow"
                        >
                          @for (role of roles; track role; let i = $index) {
                            <li
                              [ngClass]="{
                                'border-t border-base-content/20': i > 0,
                              }"
                              (click)="handleRoleChange(role)"
                            >
                              <div class="grid-flow-row gap-1">
                                <p class="font-semibold">
                                  {{ role.display_name }}
                                </p>
                                <p class="text-xs">{{ role.description }}</p>
                              </div>
                            </li>
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                } @else if (sending) {
                  <div class="mt-4 flex flex-col items-center text-center">
                    <span
                      class="loading loading-spinner loading-lg text-primary"
                    ></span>
                  </div>
                }
              </div>
              @if (invalidInvite) {
                <div class="mt-4 text-center text-error">
                  <p>{{ invalidInvite }}</p>
                </div>
              }
              <div class="modal-action">
                <button
                  class="btn btn-neutral"
                  (click)="closeInviteUserModal()"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-primary ml-4"
                  (click)="sendInvitation()"
                  [disabled]="sending"
                >
                  Send Invitation
                </button>
              </div>
            </div>
          }
        </div>
      </dialog>
    }

    @if (!errorFetchingUsers && users) {
      <div
        class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
      >
        <table
          class="table table-zebra table-pin-rows table-pin-cols table-lg static"
        >
          <thead class="text-base font-medium">
            <tr>
              <td>Email</td>
              <!-- <td>Username</td> -->
              <td>Roles</td>
              <td>Active</td>
              <td>Created</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            @for (user of users; track user) {
              <tr>
                <td>{{ user.email }}</td>
                <!-- <td>{{ user.username }}</td> -->
                <td>{{ roleList(user) }}</td>
                <td>{{ user.active }}</td>
                <td>{{ user.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}</td>
                <td class="min-w-24">
                  @if (canEditUser(user)) {
                    <button
                      class="btn btn-ghost btn-sm"
                      (click)="browseToEditUser(user)"
                    >
                      <app-edit-icon></app-edit-icon>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Mobile Active Users -->
      <div class="sm:hidden">
        @for (user of users; track user) {
          <div class="my-2 w-full rounded-lg border border-base-content/20 p-4">
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Email:</p>
              <p>{{ user.email }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Roles:</p>
              <p>{{ roleList(user) }}</p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Active:</p>
              <p>
                {{ user.active }}
              </p>
            </div>
            <div class="flex">
              <p class="pb-1 pr-3 text-base-content/70">Created:</p>
              <p>
                {{ user.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
              </p>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="pt-8">
    <div class="prose mb-4">
      <h2 class="ml-6">Pending Invitations</h2>
    </div>

    @if (errorFetchingInvitations) {
      <div class="text-center">
        <p class="text-error">Error fetching invitations</p>
      </div>
    } @else if (loadingInvitations) {
      <div class="flex justify-center">
        <div class="loading loading-spinner loading-lg"></div>
      </div>
    } @else if (pendingInvitations) {
      @if (pendingInvitations.length === 0) {
        <p class="ml-6 italic text-base-content/80">No pending invitations</p>
      }
      @if (pendingInvitations.length > 0) {
        <div
          class="hidden overflow-x-auto rounded-lg border border-base-content/20 sm:block"
        >
          <table
            class="table table-zebra table-pin-rows table-pin-cols table-lg static"
          >
            <thead class="text-base font-medium">
              <tr>
                <td>Email</td>
                <td>Used</td>
                <td>Expiration</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              @for (
                pendingInvitation of pendingInvitations;
                track pendingInvitation;
                let i = $index
              ) {
                <tr
                  [ngClass]="{
                    'bg-base-200': i % 2 === 0,
                    'bg-base-100': i % 2 !== 0,
                  }"
                >
                  <td>{{ pendingInvitation.email }}</td>
                  <td>{{ pendingInvitation.used }}</td>
                  <td>
                    {{
                      pendingInvitation.expiration | date: 'MM/dd/yyyy, hh:mmaa'
                    }}
                  </td>
                  <td
                    class="link"
                    (click)="revokeInvitation(pendingInvitation)"
                  >
                    Revoke
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Mobile Pending Users -->
        <div class="sm:hidden">
          @for (
            pendingInvitation of pendingInvitations;
            track pendingInvitation;
            let i = $index
          ) {
            <div
              class="my-2 w-full rounded-lg border border-base-content/20 p-4"
            >
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Email:</p>
                <p>{{ pendingInvitation.email }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Used:</p>
                <p>{{ pendingInvitation.used }}</p>
              </div>
              <div class="flex">
                <p class="pb-1 pr-3 text-base-content/70">Expiration:</p>
                <p>
                  {{
                    pendingInvitation.expiration | date: 'MM/dd/yyyy, hh:mmaa'
                  }}
                </p>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
